import { useEffect, useState } from 'react';
import api from './api';

/** Mirrors the backend defaults so the first paint already matches the cleaned-up dashboard (no flash of hidden blocks). */
export const DEFAULT_WIDGETS = { welcome_panel: false, student_id_pill: true, credits_card: true, unlocks_card: false, next_class_card: false, header_wallet_pill: false };

let cache = null;
let inflight = null;
const listeners = new Set();

function fetchWidgets() {
  if (!inflight) {
    inflight = api.get('/api/dashboard/widgets').then((r) => { cache = { ...DEFAULT_WIDGETS, ...(r.data || {}) }; listeners.forEach((fn) => fn(cache)); return cache; })
      .catch(() => cache || DEFAULT_WIDGETS).finally(() => { inflight = null; });
  }
  return inflight;
}

/** Admin-controlled on/off switches for the student dashboard blocks (Admin → Student Dashboard). One request per page load, shared. */
export function useDashboardWidgets(enabled = true) {
  const [w, setW] = useState(cache || DEFAULT_WIDGETS);
  useEffect(() => {
    if (!enabled) return undefined;
    listeners.add(setW);
    if (!cache) fetchWidgets(); else setW(cache);
    return () => { listeners.delete(setW); };
  }, [enabled]);
  return w;
}

export function resetDashboardWidgetsCache() { cache = null; }
